var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiDocumentIconMultiColor2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 16,
  x: 1.667,
  fill: "var(--dlMultiColorPrimary)",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M4.667 3h9v2h-9zM4.667 7h9v2h-9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.667 11h5v2h-5z"
})));
export default SvgHaidiDocumentIconMultiColor2;